import { useSuspenseQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { FinancingStagePath, financingStageQueryOptions } from "shared-ui";
import { useCustomerAppConfig } from "undercarriage";

import { useApplyForFunds } from "../../hooks/use-apply-for-funds";

import { LandingScreen } from "./landing";

export const FundingLandingPage = () => {
  const {
    data: { customerUuid, customerDomain },
  } = useCustomerAppConfig();
  const { data: financingStage } = useSuspenseQuery(financingStageQueryOptions(customerUuid));

  const standardNavigate = useNavigate();
  const { apply, isPending } = useApplyForFunds();

  // Handle initial page load navigation only
  useEffect(() => {
    // Case 1: No active application (home-page-enabled customer with nothing to route to)
    if (financingStage.stage === null) {
      standardNavigate(`/${customerDomain}/home`, { replace: true });
      return;
    }

    // Case 2: Wrong stage - redirect to appropriate page using standard navigate
    if (financingStage.stage !== "funding_application") {
      const path = [FinancingStagePath[financingStage.stage], financingStage.subStage].filter(Boolean).join("");
      const to = financingStage.stage === "company_creation" ? `/${path}` : `/${customerDomain}/${path}`;
      standardNavigate(to, { replace: true });
      return;
    }

    // Case 3: In-progress application - subStage is always a FundingApp path (e.g. /connections/banking)
    if (financingStage.subStage) {
      standardNavigate(`/${customerDomain}/funding/application${financingStage.subStage}`);
      return;
    }

    // Case 3: No subStage - stay on landing page (no action needed)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [financingStage?.stage, financingStage?.subStage]);

  // Render LandingScreen by default
  return financingStage?.stage === "funding_application" && !financingStage.subStage ? (
    <LandingScreen onSubmit={apply} isPending={isPending} />
  ) : null;
};
